/**
 * Comments Polling System
 * Checks for comment updates every 30 seconds
 */

(function() {
    'use strict';

    // Configuration
    const POLL_INTERVAL = 30000; // 30 seconds
    let lastCheckTimestamp = null;
    let pollTimer = null;
    let projectId = null;

    /**
     * Initialize polling for a project
     * @param {number} id - Project ID
     */
    function initCommentsPoll(id) {
        if (!id) {
            console.error('Project ID is required for comments polling');
            return;
        }

        projectId = id;
        lastCheckTimestamp = new Date().toISOString().slice(0, 19).replace('T', ' ');

        // Start polling
        startPolling();

        // Stop polling when page is hidden
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                stopPolling();
            } else {
                startPolling();
            }
        });

        // Stop polling when page unloads
        window.addEventListener('beforeunload', stopPolling);
    }

    /**
     * Start the polling timer
     */
    function startPolling() {
        if (pollTimer) {
            return; // Already polling
        }

        pollTimer = setInterval(checkForUpdates, POLL_INTERVAL);
        console.log('Comments polling started');
    }

    /**
     * Stop the polling timer
     */
    function stopPolling() {
        if (pollTimer) {
            clearInterval(pollTimer);
            pollTimer = null;
            console.log('Comments polling stopped');
        }
    }

    /**
     * Check for comment updates
     */
    function checkForUpdates() {
        if (!projectId) {
            return;
        }

        fetch(`/project/${projectId}/comments/updates?last_check=${encodeURIComponent(lastCheckTimestamp)}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                // Update timestamp
                lastCheckTimestamp = data.timestamp;

                // If there are updates, reload the page
                if (data.has_updates) {
                    console.log(`${data.comments_count} new comment(s) detected, reloading...`);
                    location.reload();
                }

                // Update unread count if badge exists
                if (data.unread_count !== undefined) {
                    updateUnreadBadge(data.unread_count);
                }
            }
        })
        .catch(error => {
            console.error('Error checking for comment updates:', error);
        });
    }

    /**
     * Update unread comments badge
     * @param {number} count - Unread count
     */
    function updateUnreadBadge(count) {
        const badge = document.querySelector('.comments-unread-badge');
        if (badge) {
            if (count > 0) {
                badge.textContent = count;
                badge.style.display = 'inline-block';
            } else {
                badge.style.display = 'none';
            }
        }
    }

    // Export to global scope
    window.CommentsPolling = {
        init: initCommentsPoll,
        start: startPolling,
        stop: stopPolling
    };

})();
